export default {
	moduleById(course) {
		return course.modules.reduce((dict, module) => {
			dict[module.id] = module
			return dict
		}, {})
	}
}